export default "__VITE_ASSET__0Pq0V98x__"